import { CareerItem } from '@/data/types';
import { useData } from '@/i18n/LangContext';

interface CvTimelineProps {
  items?: CareerItem[];
  title?: string;
}

export default function CvTimeline({
  items,
  title
}: CvTimelineProps) {
  const data = useData();
  const timelineItems = items ?? data.about.careerTimeline;
  return (
    <div className="space-y-6 print:space-y-2">
      {title && <h3 className="text-xl font-semibold text-white mb-4 print:text-black print:mb-2">{title}</h3>}
      
      <div className="space-y-6 print:space-y-3">
        {timelineItems.map((item, index) => (
          <div key={index} className="relative pl-8 print:break-inside-avoid print:page-break-inside-avoid print:pb-0">
            {/* Zeitlinie-Punkt */}
            <div className="absolute left-0 top-2 w-4 h-4 rounded-full bg-[#A67C52] shadow-[0_0_10px_rgba(166,124,82,0.5)] print:bg-gray-400 print:w-3 print:h-3 print:shadow-none"></div>
            
            {/* Zeitlinie-Linie */}
            {index < timelineItems.length - 1 && (
              <div className="absolute left-2 top-6 w-[1px] h-[calc(100%+12px)] bg-gradient-to-b from-[#A67C52] to-transparent print:from-gray-400 print:to-gray-100 print:h-[calc(100%+5px)]"></div>
            )}
            
            {/* Inhalt */}
            <div>
              <p className="font-mono text-sm text-[#C69C6D] mb-1 print:text-gray-700 print:mb-0">{item.year}</p>
              <p className="font-semibold text-lg text-white mb-1 print:text-black print:mb-0">{item.title}</p>
              <p className="text-white/70 italic mb-1 print:text-gray-600 print:mb-0">{item.company}{item.location && `, ${item.location}`}</p>
              
              {item.companyType && (
                <p className="text-white/60 text-sm mb-1 print:text-gray-500 print:mb-0">{item.companyType}</p>
              )}
              
              {item.description && (
                <p className="text-white/80 mb-2 print:text-black print:mb-1">{item.description}</p>
              )}
              
              {item.tasks && item.tasks.length > 0 && (
                <div className="mt-1 mb-2 print:mt-0.5 print:mb-1">
                  <p className="text-white/90 text-sm font-semibold mb-1 print:text-black print:mb-0.5">{data.ui.cv.tasks}</p>
                  <ul className="list-disc list-outside text-white/80 text-sm pl-4 space-y-1 print:text-black print:space-y-0.5">
                    {item.tasks.map((task, taskIndex) => (
                      <li key={taskIndex} className="print:text-xs">{task}</li>
                    ))}
                  </ul>
                </div>
              )}
              
              {item.clients && item.clients.length > 0 && (
                <div className="mt-1 print:mt-0.5">
                  <p className="text-white/90 text-sm font-semibold mb-1 print:text-black print:mb-0.5">{data.ui.cv.clients}</p>
                  <p className="text-white/80 text-sm print:text-black print:text-xs">{item.clients.join(', ')}</p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
} 